module.exports = __webpack_public_path__ + "static/media/Butter.ce2c3e71.jpg";